import { produce } from "immer";

import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { DataSelector, Events } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";
import {
	TreeEngineActions,
	TreeEngineSelectors
} from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";

export const moveTextbausteinMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	if (!TreeEngineActions.event.match(action)) {
		return next(action);
	}

	const { activityId, engineAction } = action.payload;
	if (!Events.onNodeEventButtonClicked.match(engineAction)) {
		return next(action);
	}

	const direction =
		engineAction.payload.button.event === "event_move_up"
			? "up"
			: engineAction.payload.button.event === "event_move_down"
				? "down"
				: undefined;

	if (!direction) {
		return next(action);
	}

	const data = TreeEngineSelectors.dataState(activityId)(api.getState());
	if (!data) {
		return { type: "none" };
	}

	const selector = direction === "up" ? DataSelector.predecessor : DataSelector.successor;
	const node = selector(engineAction.payload)(data);

	if (!node) {
		return { type: "none" };
	}

	api.dispatch(
		TreeEngineActions.event({
			activityId,
			engineAction: Events.onNodeEventButtonClicked(
				produce(engineAction.payload, draft => {
					draft.button.event = "event_cut_node";
				})
			)
		})
	);

	api.dispatch(
		TreeEngineActions.event({
			activityId,
			engineAction: Events.onNodeEventButtonClicked(
				produce(engineAction.payload, draft => {
					draft.button.event = direction === "up" ? "event_paste_above" : "event_paste_below";
					draft.nodeIdentifier = node.nodeIdentifier;
					draft.nodePath = node.nodePath;
				})
			)
		})
	);

	return { type: "none" };
});
